import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import chatbot from '~/redux/slices/chatbot';
import { Entity, EntityType } from '~/types/Entity';

import { COLLAPSED_WIDTH } from '../chat-bot-panel/constants';
import { useResolveChatBotEntity } from './useResolveChatBotEntity';

export const useAskAnything = () => {
  const dispatch = useDispatch();
  const chatbotData = useResolveChatBotEntity();
  const isChatBotVisible = useSelector(
    chatbot.selectors.selectIsChatbotVisible,
  );

  const handleToggleChatbot = () => {
    dispatch(chatbot.actions.toggleChatbot());
    dispatch(chatbot.actions.setWidth(COLLAPSED_WIDTH));
  };

  useEffect(() => {
    if (isChatBotVisible) {
      dispatch(
        chatbot.actions.setEntity(chatbotData.entity as Entity<EntityType>),
      );

      if (chatbotData.context) {
        dispatch(chatbot.actions.setContext(chatbotData.context));
      }
    }
  }, [isChatBotVisible, chatbotData.entity, chatbotData.context, dispatch]);

  useEffect(() => {
    if (chatbotData.context) {
      dispatch(chatbot.actions.setContext(chatbotData.context));
    }
  }, [chatbotData.context, dispatch]);

  return { isChatBotVisible, handleToggleChatbot, chatbotData };
};
